<template>
  <div v-if="true" class="queued-report-info w-100 border-radius--light shadow-sm" :class="reportStatus.status">
    <i :class="`fas ${reportStatus.icon} font-20`"></i>
    <span class="ml-3" v-html="renderMessage" @click="handleClick"></span>
  </div>
</template>

<script>
import {QueueReportStatuses} from "@/utils/constants/queue/queueReportStatuses";
import alert from "@/mixin/alert.mixin";

export default {
  name: "QueueReportStatus",
  mixins: [alert],
  props: {
    reportInfo: {
      type: Object | null,
      required: true
    }
  },
  computed: {
    reportStatus() {
      if(this.reportInfo)
        switch (this.reportInfo.statusId) {
          case QueueReportStatuses.Pending:
            return {
              status: 'pending',
              icon: 'fa-hourglass-half fa-flip',
              message: `Su informe está pendiente de generación. Oprima <strong><a role="button">aquí</a></strong> para cancelar esta acción.`,
              action: this.cancelHandler
            }
          case QueueReportStatuses.Running:
            return {
              status: 'running',
              icon: 'fa-spinner fa-spin',
              message: `Su informe está siendo generado. Una vez finalizado, aparecerá un enlace para descargarlo.
                        Oprima <strong><a role="button">aquí</a></strong> para cancelar esta acción.`,
              action: this.cancelHandler
            }
          case QueueReportStatuses.Completed:
            return {
              status: 'completed',
              icon: 'fa-check-circle',
              message: `Su informe ha sido generado. Este archivo expirará en <strong>24</strong> horas. Oprima <strong><a role="button">aquí</a></strong> para descargar el informe.`,
              action: this.downloadHandler
            }
          case QueueReportStatuses.Failed:
            return {
              status: 'failed',
              icon: 'fa-hourglass-end',
              message: 'Durante el proceso de ejecución del reporte, se encontró una situación de configuración que está impidiendo generar el reporte, favor de comunicarse con Asistencia MIPE.',
            }
        }
    },
    renderMessage() {
      return this.reportStatus.message;
    },
  },
  methods: {
    handleClick(event) {
      if (event.target.tagName === 'A') {
        // Check if the click was on the <a> element
        event.preventDefault();
        this.reportStatus.action();
      }
    },
    async cancelHandler() {
      const result = await this.ShowCancelModal(
        "Confirmación",
        "¿Está seguro que desea cancelar la generación del reporte?",
        "Si",
        "No"
      );
      if(result)
        this.$emit('onCancel', this.reportInfo.executionLogId);
    },
    downloadHandler() {
      this.$emit('onDownload', this.reportInfo.executionLogId);
    }
  }
}
</script>

<style lang="scss" scoped>
.queued-report-info {
  display: flex;
  align-items: center;
  padding: 8px 10px 8px 16px;
  margin-bottom: 10px;

  & span {
    font-size: 16px;
  }
}

.pending {
  background-color: #feeeb7 !important;
  & i, span {
    color: #af6717;
  }
}

.running {
  background-color: #fdeee8 !important;
  & i, span {
    color: #af4208;
  }
}

.completed {
  background-color: #d0f0e0 !important;
  & i, span {
    color: #0d764d;
  }
}

.failed {
  background-color: #ffcbc0 !important;
  & i, span {
    color: #af4208;
  }
}

@keyframes flip {
  to {
    transform: rotateX(360deg); /* Rotate the icon 360 degrees */
  }
}
.fa-flip {
  animation: flip 2s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg); /* Rotate the icon 360 degrees */
  }
}
.fa-spin {
  animation: spin 2s linear infinite;
}
</style>
